import MakeEmptyState from './MakeEmptyState';

export default MakeEmptyState;
